/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Adaugă la comandă",
  "i18n.additionalProducts.emotionalHook": "♥️ Favorit:",
  "i18n.additionalProducts.productDescription": "Descrierea produsului",
  "i18n.additionalProducts.showMore": "Mai multe informații",
  "i18n.additionalProducts.title": "Accesorii potrivite",
  "i18n.button.addToCart": "Adaugă în coș",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Confirmă",
  "i18n.button.back": "Înapoi",
  "i18n.button.cancel": "Anulează",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Închide",
  "i18n.button.continue": "Înainte",
  "i18n.button.ignore": "Ignoră",
  "i18n.button.ignoreAndContinue": "Continuă totuși",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Nicio modificare",
  "i18n.button.design": "",
  "i18n.button.photos": "Poze",
  "i18n.button.retry": "Încearcă din nou",
  "i18n.button.uploadPhotos": "Încarcă poze",
  "i18n.button.withSmartSorted": "Cu SMART SORTED",
  "i18n.button.withoutSmartSorted": "Fără SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.actionBar.duplicate": "",
  "i18n.control.actionBar.editText": "",
  "i18n.control.actionBar.leaveTextEditing": "",
  "i18n.control.actionBar.delete": "",
  "i18n.control.actionBar.rotate": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pentru o mai bună lizibilitate,  scurtează  lungimea textului / a rândului.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Fontul ales este prea mare pentru acest text. Tipul de font selectat este prea mare pentru acest text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Pentru acest text a fost aleasă dimensiunea maximă a fontului.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "A fost selectată dimensiunea minimă posibilă a fontului.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Te rugăm să adaugi un rând nou.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Inserează un rând nou sau mărește câmpul pentru text",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Te rugăm să verifici datele introduse, nu toate caracterele sunt acceptate de acest font.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Ai ajuns la limita maximă de rânduri. Numărul maxim de rânduri a fost atins.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Te rugăm să mărești câmpul pentru text.",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Această acțiune nu poate fi anulată",
  "i18n.dialog.deletePlaceholder.title": "Sigur vrei să ștergi spațiul rezervat?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Rezoluția imaginii este prea mică pentru o imprimare de calitate a motivului!",
  "i18n.dialog.smartSorted.message": "Cu SMART SORTED, poți asambla inovativ și ușor motivul din 1000 de piese, chiar dacă nu ai o imagine model.",
  "i18n.dialog.smartSorted.title": "Puzzle-Erfolgserlebnis garantiert . Satisfacție – garantată la asamblarea puzzle-ului.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Te rugăm să faci click pe „{{text}}“, pentru a modifica titlul după preferințele tale.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Titlul cutiei nu a fost modificat.",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuă făra text",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Un spațiu rezervat nu a fost modificat. ",
    "Mai multe spații rezervate nu au fost modificate."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Spații rezervate nemodificate",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Procesul a fost întrerupt din cauza duratei prea mari și nu poate fi continuat. Te rugăm să începi din nou.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "O imagine nu a putut fi încărcată. A fost eliminată din galerie și zona de editare.",
  "i18n.error.imageLoadingError.title": "Eroare de încărcare",
  "i18n.error.imageProvisionError.message": "Una sau mai multe imagini nu au putut fi procesate. Este posibil ca formatul să nu fie acceptat.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Fișierul „{{reference1}}“ nu a putut fi procesat.",
  "i18n.error.imageSelectionError.title": "Eroare la încărcarea imaginii",
  "i18n.error.imageSizeLimitExceededError.message": "Imaginea pe care ai încărcat-o are dimensiuni prea mari. Din motive tehnice, nu poate fi  procesată.\nTe rugăm să micșorezi imaginea la mai puțin de 180 de megapixeli și să o încarci din nou.",
  "i18n.error.imageSizeLimitExceededError.title": "Eroare la încărcarea imaginii",
  "i18n.error.imageUploadError.message": "Se pare că există o problemă cu conexiunea la internet.\nTe rugăm să încerci din nou mai târziu.",
  "i18n.error.imageUploadError.title": "Eroare la încărcarea imaginii",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Fontul este nefuncțional eronat și nu poate fi utilizat.",
  "i18n.error.invalidCharConfigError.title": "Font eronat",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Se pare că conexiunea ta la internet a fost întreruptă. Poți continua procesul de creare imediat ce conexiunea este restabilită.",
  "i18n.error.templateLoadingError.message": "Șablonul „{{ error.reference[0] }}“ nu a putut fi încărcat.\nTe rugăm să încerci din nou mai târziu.",
  "i18n.error.templateLoadingError.title": "Eroare de încărcare",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "Formatul imaginii nu este acceptat pentru „{{reference1}}“.",
  "i18n.error.unsupportedMediaTypeError.title": "Eroare la încărcarea imaginii",
  "i18n.error.uploadProductError.message": "Unul sau mai multe produse nu au putut fi transferate către server.\nPosibil să existe o problemă cu conexiunea la Internet.",
  "i18n.error.uploadProductError.title": "Eroare de transmitere",
  "i18n.error.zoomModeError.message": "Textul tău din designul anterior nu a putut fi preluat și a fost resetat.",
  "i18n.error.zoomModeError.title": "Textul nu a fost preluat.",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Preț",
  "i18n.price.reduction": "Economisești",
  "i18n.price.total": "Preț total",
  "i18n.priceDisplay.times": [
    "{{value}} Bucată à {{pricePerUnit}}",
    "{{value}} Bucăți à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Alege accesorii",
  "i18n.progressOverlay.message.lines.one": "Îți mulțumim pentru creația frumoasă!",
  "i18n.progressOverlay.message.lines.two": "Pregătim totul pentru tine...",
  "i18n.template.insertText": "Introdu textul aici",
  "i18n.toolbox.image.title": "Editează imaginea",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 imagine",
    "{{value}} imagini"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "Previzualizare 3D",
  "i18n.toolbox.productChooser.title": "Schimbă produsul",
  "i18n.toolbox.productChooser.triggerText": "Produs",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Editează textul",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleRoRO {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
